<template>
    <div class="vx-row relative">
        <div class="vx-col" :class="detailsOpen ? 'w-1/2' : 'w-full'" style="transition: all 0.3s">
            <vx-card>
                <vx-server-side-table
                    ref="lineTable"
                    class="general-practitioners-table"
                    v-model="selectedGeneralPractitioner"
                    :fetch-data="$api.admin.generalPractitioner.fetch"
                    :columns="columns"
                    @page-results-changed="pagedResultsChanged"
                    enable-search
                    paginate
                ></vx-server-side-table>
            </vx-card>
        </div>
        <transition
            appear
            name="slide-fade-right"
            @after-enter="() => setDetailPosition(selectedElement)"
        >
            <div v-if="detailsOpen" class="vx-col w-1/2 absolute" style="right: 0">
                <div ref="pointer" :style="pointerPosition" class="line-detail-pointer" />
                <general-practitioner-line-detail
                    v-if="selectedGeneralPractitioner"
                    ref="detail"
                    class="line-detail-pane mb-6"
                    :style="detailPosition"
                    :generalPractitioner="selectedGeneralPractitioner"
                    @close-detail="closeDetail"
                    @updated="updateGP"
                />
            </div>
        </transition>
    </div>
</template>

<script>
import GeneralPractitionerLineDetail from './GeneralPractitionerLineDetail.vue'
import mixin from '../../crm/apps/tableMixin'
import { mapGetters } from 'vuex'
import UserAvatar from '../../../components/project/UserProfiles/UserAvatar.vue'
import { mapParams } from '../../../plugins/mappers'

export default {
    name: 'general-practitioners-table',
    mixins: [mixin],
    components: { GeneralPractitionerLineDetail, UserAvatar },
    watch: {
        selectedGeneralPractitioner: {
            handler: function (val) {
                if (val) {
                    this.generalPractitionerId = val.id
                    this.setSelectedElement(val)
                }
            },
            immediate: true
        },
        selectedElement: {
            handler: function (val) {
                this.setDetailPosition(val)
            },
            immediate: true
        }
    },
    data() {
        return {
            detailPosition: 'top: 0;',
            pointerPosition: 'top: 1.5rem;',
            selectedElement: null,
            selectedGeneralPractitioner: null
        }
    },
    computed: {
        ...mapGetters({}),
        ...mapParams({
            generalPractitionerId: 'generalPractitionerId'
        }),
        columns() {
            return [
                {
                    title: 'ID',
                    value: 'id',
                    visible: this.userHasRole(['SuperUser'])
                },
                {
                    title: 'Name',
                    value: 'name',
                    sort: 'name'
                },
                {
                    title: 'Primary Practice',
                    value: (row) => (row.primaryPracticeName ? row.primaryPracticeName : 'NA'),
                    sort: 'primaryPracticeName'
                }
            ]
        },
        detailsOpen() {
            return !!this.selectedGeneralPractitioner
        }
    },
    methods: {
        async getGeneralPractitionerById(id) {
            try {
                return await this.$api.admin.generalPractitioner.fetchById(id)
            } catch (error) {
                console.error(error)
            }
        },
        async getPracticeById(id) {
            try {
                return await this.$api.admin.practice.fetchById(id)
            } catch (error) {
                console.error(error)
            }
        },
        // server side
        setSelectedElement(generalPractitioner) {
            this.$nextTick(() => {
                if (!generalPractitioner) {
                    this.selectedElement = null
                    return
                }
                // FIX ME: needs to calculate based on the ID of the table
                var data = this.$refs.lineTable.$refs.table.indexedData
                var foundRow = data.filter((v) => {
                    return v.id == generalPractitioner.id
                })
                if (foundRow.length == 0) {
                    this.selectedElement = null
                    return
                }
                var activeIndex = foundRow[0].xIndex

                var activeRow = this.$refs.lineTable.$refs.table.$refs[activeIndex]
                if (activeRow) {
                    activeRow = activeRow[0] && activeRow[0].$el
                }

                this.selectedElement = activeRow
            })
        },
        updateGP(generalPractitioner) {
            this.$refs.lineTable.updateRecord({
                ...generalPractitioner,
                primaryPracticeName: generalPractitioner.primaryPractice.name
            })
        },
        // setSelectedElementClientSide(generalPractitioner) {
        //     this.$nextTick(() => {
        //         if (!generalPractitioner) {
        //             this.selectedElement = null
        //             return
        //         }
        //         // FIX ME: needs to calculate based on the ID of the table
        //         var data = this.$refs.lineTable.$refs.table.data
        //         var foundRow = data.filter((v) => v.id == generalPractitioner.id)
        //         var activeIndex = foundRow[0].xIndex

        //         var activeRow =
        //             this.$refs.lineTable.$refs.table.$refs.table.children[1].children[activeIndex] //this.$refs.lineTable.$refs.table.$refs[activeIndex]
        //         // if (activeRow) {
        //         //     activeRow = activeRow[0] && activeRow[0].$el
        //         // }
        //         // if (!activeRow) {
        //         //     //
        //         // }

        //         this.selectedElement = activeRow
        //     })
        // },
        closeDetail() {
            this.selectedGeneralPractitioner = null
            this.generalPractitionerId = null
        },
        setDetailPosition(row, scrollTo) {
            row = row || this.selectedElement
            if (!row) {
                return
            }
            this.$nextTick(() => {
                // get elements
                var detail = this.$refs.detail.$el
                var pointer = this.$refs.pointer
                var container = this.$el

                // get bounding rects
                var containerRect = container.getBoundingClientRect()
                var rowRect = row.getBoundingClientRect()

                // Center the pointer on the selected line
                var targetTop = rowRect.top - containerRect.top
                var pointerTargetTop = targetTop + (row.offsetHeight - pointer.offsetHeight) / 2
                this.pointerPosition = `top: ${pointerTargetTop}px;`

                if (container.offsetHeight > detail.offsetHeight) {
                    var containerOffset = container.offsetHeight - targetTop - detail.offsetHeight
                    if (containerOffset < 0) {
                        // containerOffset is negative, hence, this will negate any overflow
                        // distance past the bottom of the container
                        targetTop += containerOffset + 17
                    }
                    // 17 is the height of the head row and represents the max
                    // extra distance That can be used as padding before the pointer
                    this.detailPosition = `top: ${targetTop - 17}px;`
                } else {
                    this.detailPosition = `top: ${0}px;`
                }
            })
        },
        pagedResultsChanged() {
            if (this.selectedGeneralPractitioner) {
                this.selectedElement = null
                this.setSelectedElement(this.selectedGeneralPractitioner)
            }
        }
    },
    mounted() {},
    async created() {}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';
.line-detail-pane {
    border-left: 2px solid rgba(var(--vs-primary), 1);
}

.line-detail-pointer {
    width: 25px;
    height: 25px;
    transform: rotate(45deg);
    position: absolute;
    left: 2px;
    background-color: rgba(var(--vs-primary), 1);
    transition: all 0.35s ease;
}

div.disable-events {
    pointer-events: none;
}
</style>
